var PreviewUnityMode;
(function (PreviewUnityMode) {
    PreviewUnityMode["Authentication"] = "authentication";
    PreviewUnityMode["Builder"] = "builder";
    PreviewUnityMode["Marketplace"] = "marketplace";
    PreviewUnityMode["Profile"] = "profile";
    PreviewUnityMode["Configurator"] = "configurator";
})(PreviewUnityMode || (PreviewUnityMode = {}));
export { PreviewUnityMode };
//# sourceMappingURL=WearablePreview.types.js.map